export const CLEAR_BUTTON_WIDTH = '150px';
